export default class ResetIssueFilterStatusError extends Error {
    
}
